export enum FileTypes {
  ALL_IMAGES = 'image/*',
  AVI = '.avi',
  DOC = '.doc',
  DOCX = '.docx',
  GIF = '.gif',
  JPEG = '.jpeg',
  JPG = '.jpg',
  MP4 = '.mp4',
  PDF = '.pdf',
  PNG = '.png',
  PPT = '.ppt',
  PPTX = '.pptx',
  ODT = '.odt',
  SVG = '.svg',
  WMV = '.wmv',
  XLS = '.xls',
  XLSX = '.xlsx',
  ZIP = '.zip',
  RAR = '.rar',
}

export enum ImageTypes {
  GIF = '.gif',
  JPEG = '.jpeg',
  JPG = '.jpg',
  PNG = '.png',
}
